import React, { useState, useEffect } from "react";

import { connect } from "react-redux";

import { NavLink } from "react-router-dom";

// Sidebar links always open a list fresh (first page, no search or filters); only going back and forth between
// pages brings back a list's place. The changing value also restarts the page when it is already open.
const freshListState = () => ({ freshList: Date.now() });
import { setSidebarToggleMobile } from "../../../store/reducers/ThemeOptions";

import { AiOutlineMenu } from "react-icons/ai";
import { MdExpandMore } from "react-icons/md";
import { FaGavel, FaUserFriends, FaUser, FaCog, FaInfoCircle, FaPaperclip } from "react-icons/fa";
import {
    Link,
    List,
    ListItem,
    Collapse,
} from "@mui/material";
import ConfirmationDialog from "@/components/Modal/ConfirmationDialog";
import useHistory from "../../../hooks/useHistory";
import { SHOW_INTEGRATION } from "../../../helpers/FeatureFlags";

//TODO ARNO
//Active flags and styles on nav links have been removed in the latest version of react
// => need to either extend the component with the logic or research a different way to do it
// => seems to be working without modifications => Need more testing 

const SidebarMenu = (props) => {
    const history = useHistory();

    const { setSidebarToggleMobile, sidebarUserbox } = props;

    const toggleSidebarMobile = () => setSidebarToggleMobile(false);
    const [confirmationModalToggle, setConfirmationModalToggle] = useState(false);
    const [collapseShow, setCollapseShow] = React.useState({
        auctionCollapse: true,
        systemSettingsCollapse: false,
        systemDocumentationCollapse: false,
        listingsCollapse: false
    })

    useEffect(() => {
        confirmationModalToggle && closeConfirmationModal();
    }, [history.location.key])

    const showConfirmationModalToggle = () => {
        setConfirmationModalToggle(true);
    }

    const closeConfirmationModal = () => {
        setConfirmationModalToggle(false);
    }

    const openTrainingDocuments = () => {
        closeConfirmationModal();
        if (props.settings.ProductTrainingDocuments) window.open(props.settings.ProductTrainingDocuments);
    }

    const openIntroPack = () => {
        if (props.settings.ProductIntroPack) window.open(props.settings.ProductIntroPack);
    }


    const LotTypesNavigation = () => {
        if (props.settings.ProductName === "PremBid") {
            return <NavLink
                style={{ borderRadius: 100 }}
                className={"nav-link-simple" + " font-weight-normal"}
                onClick={toggleSidebarMobile}
                to="/LotTypes"
                state={freshListState()}
            >
                {props.settings.LotName + " Types"}
            </NavLink>
        } else {
            return <></>
        }
    }

    return (
        <>
            <div className="sidebar-navigation">
                <div className="sidebar-header text-white font-weight-normal">
                    <span>Navigation menu</span>
                </div>
                <List className="p-2">
                    <ListItem style={{ cursor: "pointer" }} alignItems="flex-start" className="py-3" onClick={() => { setCollapseShow({ ...collapseShow, auctionCollapse: !collapseShow.auctionCollapse }) }}>
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--1">
                                    <FaGavel size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1, display: 'inline-flex', alignItems: 'center' }}>
                                <a className="hide">
                                    <span className="text-white mx-3 font-weight-bold" >{props.settings.AuctionName + "s"}</span>
                                </a>
                                <span className="sidebar-collapsed hide" style={{ position: 'absolute', right: 0 }}>
                                    <MdExpandMore className={"pb-nav-chevron" + (collapseShow.auctionCollapse ? " is-open" : "")} size={20} />
                                </span>
                            </div>
                        </div>
                    </ListItem>
                    <Collapse className="mx-4 hide" in={collapseShow.auctionCollapse} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/Auctions"
                                    state={freshListState()}
                                >
                                    {props.settings.AuctionName + "s/Create " + props.settings.AuctionName}
                                </NavLink>
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/AuctionManagement"
                                    state={freshListState()}
                                >
                                    {props.settings.AuctionName + " Management"}
                                </NavLink>
                            </ListItem>
                        </List>
                    </Collapse>
                    <ListItem alignItems="flex-start" className="py-3">
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--2">
                                    <AiOutlineMenu size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1 }}>
                                <NavLink
                                    onClick={toggleSidebarMobile}
                                    to="/Lots"
                                    state={freshListState()}
                                    className="hide"
                                >
                                    <span className=" text-white mx-3 font-weight-bold">{props.settings.LotName + "s"}</span>
                                </NavLink>
                            </div>
                        </div>

                    </ListItem>
                    <ListItem alignItems="flex-start" className="py-3">
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--3">
                                    <FaUser size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1 }}>
                                <NavLink
                                    onClick={toggleSidebarMobile}
                                    to="/Contacts"
                                    state={freshListState()}
                                    className="hide"
                                >
                                    <span className=" text-white mx-3 font-weight-bold">Contacts/Agents</span>
                                </NavLink>
                            </div>
                        </div>

                    </ListItem>
                    <ListItem alignItems="flex-start" className="py-3">
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--4">
                                    <FaUserFriends size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1 }}>
                                <NavLink
                                    onClick={toggleSidebarMobile}
                                    to="/Users"
                                    state={freshListState()}
                                    className="hide"
                                >
                                    <span className=" text-white mx-3 font-weight-bold">Users</span>
                                </NavLink>
                            </div>
                        </div>

                    </ListItem>
                    <ListItem style={{ cursor: "pointer" }} alignItems="flex-start" className="py-3" onClick={() => {
                        setCollapseShow({ ...collapseShow, systemSettingsCollapse: !collapseShow.systemSettingsCollapse })
                    }}>
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--5">
                                    <FaCog size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1, display: 'inline-flex', alignItems: 'center' }}>
                                <a className="hide">
                                    <span className=" text-white mx-3 font-weight-bold">System Management</span>
                                </a>
                                <span className="sidebar-icon hide" style={{ position: 'absolute', right: 0 }}>
                                    <MdExpandMore className={"pb-nav-chevron" + (collapseShow.systemSettingsCollapse ? " is-open" : "")} size={20} />
                                </span>
                            </div>
                        </div>
                    </ListItem>
                    <Collapse className="mx-4 hide" in={collapseShow.systemSettingsCollapse} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem alignItems="flex-start">
                                <LotTypesNavigation />
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/DocumentTemplates"
                                    state={freshListState()}
                                >
                                    Documents
                                </NavLink>
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/IncrementTable"
                                    state={freshListState()}
                                >
                                    {"Increment Tables"}
                                </NavLink>
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/BankDetails"
                                    state={freshListState()}
                                >
                                    Bank Details
                                </NavLink>
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/BiddingCalculations"
                                    state={freshListState()}
                                >
                                    Bidding Calculations
                                </NavLink>
                            </ListItem>
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/Venue"
                                    state={freshListState()}
                                >
                                    Venues
                                </NavLink>
                            </ListItem>
                            {/* Integration is switched off for now (helpers/FeatureFlags.ts). */}
                            {SHOW_INTEGRATION && (
                            <ListItem alignItems="flex-start">
                                <NavLink
                                    style={{ borderRadius: 100 }}
                                    className={"nav-link-simple" + " font-weight-normal"}
                                    onClick={toggleSidebarMobile}
                                    to="/Integration"
                                    state={freshListState()}
                                >
                                    Integration
                                </NavLink>
                            </ListItem>
                            )}
                        </List>
                    </Collapse>
                    <ListItem style={{ cursor: "pointer" }} alignItems="flex-start" className="py-3" onClick={() => {
                        setCollapseShow({ ...collapseShow, systemDocumentationCollapse: !collapseShow.systemDocumentationCollapse })
                    }}>
                        <div className="hide-icon" style={{ flexDirection: 'row', display: 'inline-flex' }}>
                            <div>
                                <span className="pb-nav-icon pb-nav-icon--6">
                                    <FaInfoCircle size={17} />
                                </span>
                            </div>
                            <div style={{ flexDirection: 'row', flex: 1, display: 'inline-flex', alignItems: 'center' }}>
                                <a className="hide">
                                    <span className=" text-white mx-3 font-weight-bold">System Documentation</span>
                                </a>
                                <span className="hide" style={{ position: 'absolute', right: 0 }}>
                                    <MdExpandMore className={"pb-nav-chevron" + (collapseShow.systemDocumentationCollapse ? " is-open" : "")} size={20} />
                                </span>
                            </div>
                        </div>
                    </ListItem>
                    <Collapse className="mx-4 hide" in={collapseShow.systemDocumentationCollapse} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem style={{ cursor: "pointer" }} alignItems="flex-start">
                                <Link
                                    style={{ borderRadius: 100 }}
                                    onClick={showConfirmationModalToggle}
                                    className={"nav-link-simple" + " font-weight-normal"}>
                                    System Training
                                </Link>
                            </ListItem>
                            {
                                props.settings.ProductIntroPack &&
                                <ListItem style={{ cursor: "pointer" }} alignItems="flex-start">
                                    <Link
                                        style={{ borderRadius: 100 }}
                                        onClick={openIntroPack}
                                        className={"nav-link-simple" + " font-weight-normal"}>
                                        {props.settings.AuctionName} Introduction Pack
                                    </Link>
                                </ListItem>
                            }
                        </List>
                    </Collapse>
                </List>
            </div>

            {confirmationModalToggle && <ConfirmationDialog
                open={confirmationModalToggle}
                okButtonText="Ok"
                cancelButtonText="Cancel"
                description={"This documentation is private and confidential, and you, the user, admin entity, hereby accept that the documentation cannot be distributed, shared or made available to any third party or for any purpose other than training on how to use the admin portal of the solution"}
                title={"Confidentiality Acceptance"}
                onCancel={closeConfirmationModal}
                onOk={openTrainingDocuments}
            />}
        </>
    );
};

const mapStateToProps = (state) => ({
    sidebarUserbox: state.ThemeOptions.sidebarUserbox,
    sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile,
    sidebarToggle: state.ThemeOptions.sidebarToggle,
    settings: state.settings.settings,
});

const mapDispatchToProps = (dispatch) => ({
    setSidebarToggleMobile: (enable) => dispatch(setSidebarToggleMobile(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);
